import { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { stopInactivityLogout } from '../Auth/inactivityService';

const useAppLevelAuth = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(!!localStorage.getItem('token'));
  const history = useHistory();

  const logout = () => {
    stopInactivityLogout();
    localStorage.clear();
    setIsLoggedIn(false);
    history.push('/');
    window.location.reload();
  };

  useEffect(() => {
    const checkAuth = () => {
      setIsLoggedIn(!!localStorage.getItem('token'));
    };

    window.addEventListener('storage', checkAuth);
    return () => window.removeEventListener('storage', checkAuth);
  }, []);

  return { isLoggedIn, logout };
};

export default useAppLevelAuth;